
import FIcon from '@/components/atoms/icons/h-icon';

export default {
  name: 'PensionGapPieChartCta',

  components: {
    FIcon,
  },

  props: {
    text: {
      type: String,
      default: '',
    },
  },

  methods: {
    scrollToPlayground(section) {
      this.$vuetify.goTo(section, {
        offset: 12,
        easing: 'easeInOutCubic',
      });
    },
  },
};
